<template>
  <div class="hm-check-box-group mt-1" :class="{ checked: modelValue }">
    <HMCheckBox
      class="check-box me-3"
      :style-type="styleType"
      :modelValue="modelValue"
      @update:modelValue="newValue => $emit('update:modelValue', newValue)"
    >
      <span>{{ inputModel }}</span>
    </HMCheckBox>
  </div>
</template>

<script lang="ts">
interface LocalProps {
  modelValue: PropOptions;
  inputValue: PropOptions;
  styleType: PropOptions<StyleType>;
}

export default {
  name: 'HMCheckBoxGroupStudent',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: String,
      default: null,
    },
    styleType: {
      type: String,
      default: 'circle',
    },
  } as LocalProps,
  data() {
    return {
      inputModel: this.inputValue,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.hm-check-box-group {
  display: flex;
  background-color: transparent;
  padding: 0.75rem 0.25rem;
  width: fit-content;
  border-radius: $border-radius;
  color: $charcoal;

  &:hover {
    background-color: $light-gray;
  }

  &.checked {
    background-color: var(--brand-color-with-opacity-03);
  }
}

.check-box :deep(.check-mark) {
  background-color: white;
}
</style>
